import Base from "../base";

export default class EmpresaServices extends Base {
    static endpointUrl = "empresas/"
}